import React from 'react';
import './PaymentSuccess.css';

interface PaymentSuccessProps {
  paymentIntent: any;
  onBackToDashboard: () => void;
  onViewReceipt?: () => void;
  onMakeAnotherPayment?: () => void;
}

const PaymentSuccess: React.FC<PaymentSuccessProps> = ({
  paymentIntent,
  onBackToDashboard,
  onViewReceipt,
  onMakeAnotherPayment
}) => {
  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD'
    }).format(amount / 100);
  };

  const formatDate = (timestamp: number) => {
    return new Date(timestamp * 1000).toLocaleDateString('en-CA', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="payment-success-modal">
      <div className="payment-success-content">
        <div className="success-header">
          <div className="success-icon">
            <div className="checkmark">
              <div className="checkmark-circle">
                <div className="checkmark-stem"></div>
                <div className="checkmark-kick"></div>
              </div>
            </div>
          </div>
          <h2>Payment Successful!</h2>
          <p className="success-message">
            Your payment has been processed successfully. You will receive a confirmation email shortly.
          </p>
        </div>

        <div className="payment-details">
          <h3>Payment Details</h3>
          <div className="detail-row">
            <span className="label">Transaction ID:</span>
            <span className="value">{paymentIntent.id}</span>
          </div>
          <div className="detail-row">
            <span className="label">Amount:</span>
            <span className="value amount">{formatAmount(paymentIntent.amount)}</span>
          </div>
          <div className="detail-row">
            <span className="label">Status:</span>
            <span className="value status success">{paymentIntent.status}</span>
          </div>
          <div className="detail-row">
            <span className="label">Date:</span>
            <span className="value">{formatDate(paymentIntent.created)}</span>
          </div>
          {paymentIntent.description && (
            <div className="detail-row">
              <span className="label">Description:</span>
              <span className="value">{paymentIntent.description}</span>
            </div>
          )}
        </div>

        <div className="next-steps">
          <h3>What's Next?</h3>
          <ul>
            <li>✅ Your session pack has been activated</li>
            <li>📧 You'll receive a confirmation email</li>
            <li>📅 Check your dashboard for upcoming sessions</li>
            <li>📱 Contact us if you have any questions</li>
          </ul>
        </div>

        <div className="success-actions">
          <button
            onClick={onBackToDashboard}
            className="btn btn-primary"
          >
            🏠 Back to Dashboard
          </button>
          
          {onViewReceipt && (
            <button
              onClick={onViewReceipt}
              className="btn btn-secondary"
            >
              📄 View Receipt
            </button>
          )}
          
          {onMakeAnotherPayment && (
            <button
              onClick={onMakeAnotherPayment}
              className="btn btn-outline"
            >
              💳 Make Another Payment
            </button>
          )}
        </div>

        <div className="support-info">
          <h4>Need Help?</h4>
          <p>
            If you have any questions about your payment or session pack, 
            please don't hesitate to contact us:
          </p>
          <div className="contact-info">
            <p>📧 Email: support@oarayouthinnovationlab.com</p>
            <p>📞 Phone: (555) 123-4567</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
